angular.module("vgresiduos").controller("GenericKpiReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorios-personalizados/kpi");
		};
	}
]);
